import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Form from '../form/Form';
import LoyaltyContext from './LoyaltyContext';

const LocalCustomerSearch = ({ onSelect = () => {}, customerNum = '' }) => {
  const { fetchCustomer } = useContext(LoyaltyContext);

  const layout = [
    {
      name: 'externalCustomerId',
      label: 'External Customer',
      col: 12,
      validation: {
        type: 'db',
        modelName: 'loyaltycustomer',
        serverFilter: { customerNum: customerNum.toLowerCase() },
      },
      required: true,
    },
  ];

  const handleSubmit = ({ externalCustomerId }) => {
    return fetchCustomer(externalCustomerId).then(({ data }) => {
      onSelect(data);
    });
  };

  return <Form layout={layout} hideCancel exportFormat="object" submit={handleSubmit} submitAll feedback="none" />;
};

LocalCustomerSearch.propTypes = {
  onSelect: PropTypes.func,
  customerNum: PropTypes.string,
};

export default LocalCustomerSearch;
